module.exports = __webpack_public_path__ + "Server-NeedsUpgrade.TentaclePassive.0c7ce5785bafa7cadddee3cf9abdd71a.hashedasset.svg";